<script lang="ts">
  import type { VerifyInputParamType } from '$shared/components/types';
  import InputValue from './InputValue.svelte';

  interface Props {
    list?: VerifyInputParamType[];
    active?: string;
    disabled?: boolean;
    onadd?: (param: any) => void;
    onchange?: (id: string) => void;
  }

  let { list = [], active = '', disabled = false, onadd, onchange }: Props = $props();

  const onRadioChange = (item: VerifyInputParamType): void => {
    onchange?.(item.id);
  };
</script>

<div class="comp-custom-input">
  <div class="header">
    <div data-cy="additionalInput-title" class="title">Select one</div>
    <div data-cy="additionalInput-desc" class="desc">
      This verification requires one of the following options.
    </div>
  </div>
  <div class="inputs">
    {#each list as item}
      <label for={item.id} class="radio-input">
        <input
          class="input"
          type="radio"
          {disabled}
          id={item.id}
          checked={active === item.id}
          onchange={() => onRadioChange(item)}
        />
        <div class="input-values">
          {#each item.params as param}
            <div class="input-value">
              <div data-cy={`${param.label}-k`} class="text" class:required={param.required}>
                {param.label}
              </div>
              <div class="values">
                {#each param.values as value}
                  <div class="value-i">
                    <InputValue name={param.label} {disabled} {value} type={param.type} {onadd} />
                  </div>
                {/each}
              </div>
            </div>
          {/each}
        </div>
      </label>
    {/each}
  </div>
</div>

<style>
  .comp-custom-input {
    margin: 24px 0;
  }
  .comp-custom-input .header {
    font-size: 11px;
    font-weight: normal;
    line-height: 18px;
  }
  .comp-custom-input .desc {
    color: var(--grey-medium);
  }
  .comp-custom-input .inputs {
    padding-top: 24px;
  }
  .comp-custom-input .inputs .radio-input {
    display: flex;
    align-items: flex-start;
  }
  .comp-custom-input .inputs .radio-input:not(:last-child) {
    margin-bottom: 16px;
  }
  .radio-input .text {
    width: calc(100px - 13px);
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    position: relative;
    flex-shrink: 0;
    padding: 0 8px;
  }
  .radio-input .text.required::after {
    content: '*';
    margin-left: 2px;
  }
  .radio-input .input {
    margin-top: 5px;
  }
  .input-values {
    display: inline-flex;
    flex-direction: column;
    width: 100%;
  }
  .input-value:not(:first-child) {
    margin-top: 12px;
  }
  .input-value {
    display: inline-flex;
  }
  .values {
    width: 100%;
  }
  .value-i:not(:only-child):not(:last-child) {
    padding-bottom: 8px;
  }
  .value-i:not(:first-child) {
    padding-top: 8px;
    border-top: 1px solid #e6e6e6;
  }
</style>
